module.exports = __webpack_public_path__ + "img/ring_skip_skip_1_0.0480239a.png";